import React, {useState, useEffect} from "react";
import axios from "axios";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import Card from "../../Components/Cards/Card";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useForm} from "react-hook-form";
import FileInput from "../../Components/Inputs/FileInput";
import {useSelector} from "react-redux";
import swal from "sweetalert";

export default function () {
  const user = useSelector(state => state.user);
  const isAdmin = user?.roles?.includes('Super Admin');

  const {handleSubmit, control, reset} = useForm({
    defaultValues: {shop_id: null, prices: null}
  });

  const [errors, setErrors] = useState({});
  const [shops, setShops] = useState([]);

  const [templateLink, setTemplateLink] = useState(null);

  useEffect(() => {
    axios.post(`/product/export_urls`).then(res => {
      setTemplateLink(res?.data?.categories);
    });

    if (isAdmin) {
      axios.get(`/shops/list`).then(res => {
        setShops(res.data.shops);
      });
    }
  }, []);

  const importProductCategories = data => {
    let formData = new FormData;

    formData.append('shop_id', data.shop_id || '')
    formData.append('categories', data.categories || '');

    axios.post('/product/import/categories', formData).then(res => {
      swal(res.data.message, {
        icon: "success",
      });

      reset({});
      setErrors({});
    }).catch(error => {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      } else {
        swal(error.message, {
          icon: "error",
        });
      }
    });
  }

  return (
    <Card title="Import product categories">
      {templateLink && (
        <a href={templateLink} className="btn btn-primary me-2 mb-4 mt-1 download_product_template">
          <i className="fas fa-download"></i> Products categories template
        </a>
      )}

      <form className="form w-100 row" onSubmit={handleSubmit(importProductCategories)}>
        {isAdmin && (
          <ReactSelectInput
            label="Shop"
            name="shop_id"
            control={control}
            errorMessage={errors?.shop_id}
            options={shops}
            inputClassName='mt-5'
          />
        )}

        <FileInput
          label="Products categories"
          name="categories"
          control={control}
          errorMessage={errors?.categories}
        />

        <div className="col-12">
          <SubmitButton
            title="Import"
            classes="w-auto d-inline-block mt-3"
          />
        </div>
      </form>
    </Card>
  );
}